import { render, staticRenderFns } from "./user-avatar.vue?vue&type=template&id=0bab2f30&scoped=true&"
import script from "./user-avatar.vue?vue&type=script&lang=js&"
export * from "./user-avatar.vue?vue&type=script&lang=js&"
import style0 from "./user-avatar.vue?vue&type=style&index=0&id=0bab2f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bab2f30",
  null
  
)

export default component.exports